module.exports = __webpack_public_path__ + "img/juventus.146e0f3a.png";